import styled, { css } from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';

export const MicroservicesTilesWrapper = styled.div<{ sectionHeight?: number }>(
    ({ sectionHeight }) => css`
        ${sectionHeight && `height: ${sectionHeight}px;`}
    `,
);

export const MicroservicesTilesInnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TilesTitle = styled(Typography.TextH2_28_44)`
    margin-bottom: 8px;
`;

export const TilesButtons = styled.div`
    column-gap: 16px;
    display: flex;
    row-gap: 8px;
`;

//TOOD: SPD-4331 add props responsible for reset min-width in Button
export const TileButton = styled(Button)`
    min-width: unset;
`;

export const SubsidiaryWarningWrapper = styled.div(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.background};
        border-radius: ${radius['8']}px;
        margin-top: 4px;
        padding: 24px 32px 24px 24px;
    `,
);

export const SwitchToEntity = styled.span(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.tertiary.default};
        cursor: pointer;
        font-weight: ${fontWeight.bold};
    `,
);

export const SwitchToEntityText = styled(Typography.TextBody_14_20)`
    margin-top: 8px;
`;
